import React from "react";
import { JitsiManager } from "../data";
import PerformanceStage from "./PerformanceStage";

export interface AudienceViewProps {
    roomName: string;
}

export default class AudienceView extends React.Component<AudienceViewProps> {
    public render() {
        return (
            <JitsiManager isHost={false} roomName={this.props.roomName} showWelcomeDialog={false}>
                {(props) => <PerformanceStage {...props} />}
            </JitsiManager>
        );
    }
}
